import { createApi } from '@reduxjs/toolkit/query/react'

import StorageKeys from 'src/core/classes/cache/StorageKeys'
import { IHPOrg } from 'src/core/classes/models/IReference'

import { getProcedureUrl } from './helpers/getBaseUrl'
import { getCustomQuery } from './helpers/getCustomQuery'
import { getResponseHandler } from './helpers/getResponseHandler'

export const referenceOrganizationsApi = createApi({
  reducerPath: '@app/api/referenceOrganizations',
  baseQuery: getCustomQuery({
    storageKey: StorageKeys.organisations,
    baseUrl: getProcedureUrl('spHpOrgs'),
  }),
  endpoints: (builder) => ({
    getReferenceOrganizations: builder.query<IHPOrg[], void>({
      query: () => {
        return {
          url: ``,
          method: 'POST',
          responseHandler: getResponseHandler({
            storageKey: StorageKeys.organisations,
            prepareValue: (response) => {
              return response.map((el: any) => {
                return { name: el.HPOrg, value: el.HPOrg, market: el.GeoMarket }
              })
            },
          }),
        }
      },
    }),
  }),
})

export const { useGetReferenceOrganizationsQuery } = referenceOrganizationsApi
